// flow weak

import React, {
  PureComponent
}                             from 'react';
import PropTypes              from 'prop-types';
import AnimatedView           from '../../../../components';
import styles                 from './style'
import {
  defaultOptions,
  checkStatus,
  parseJSON,
  getLocationOrigin
}                     from '../../../../services/fetchTools';
import { withRouter } from 'react-router';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import TimePicker from 'react-times';
import 'react-times/css/classic/default.css';
import { Multiselect } from 'react-widgets';

class HostGame extends PureComponent {
  static propTypes = {
    actions: PropTypes.shape({
      enterPage: PropTypes.func,
      leavePage: PropTypes.func,
    })
  };

  constructor(props) {
    super(props);
    this.state = {
      selected_one: {
        venue: this.props.venue? this.props.venue : '',
        game_type: '',
        date: moment(),
        start_time: '00:00',
        game_level_id: 1,
        end_time: '00:00',
        price: 200,
        batch_size: 14,
      },
      venues: [],
      game_types: [],
      game_levels: [],
      data_uploaded: false,
      data_error: false,
      selected_buddies: [],
      buddies: [],
      temp_buddies: [],
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDate = this.handleDate.bind(this);
    this.onStartTimeChange = this.onStartTimeChange.bind(this)
    this.onEndTimeChange = this.onEndTimeChange.bind(this)
    this.handleVenueChange = this.handleVenueChange.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onChange = this.onChange.bind(this);
  }


  componentDidMount() {
    this.getFixtureList();
    this.getAllBuddies();
  }

  getFixtureList() {
     const url = `${getLocationOrigin()}/eagleeye/get_details_for_fixture_creation/`;
     const options = {...defaultOptions};

     fetch(url, options)
       .then(checkStatus)
       .then(parseJSON)
       .then(data => this.setState({ venues: data.venues },()=>{this.setData(data)}))
       .catch(error => error);
  }

  getAllBuddies(){
    const url = `${getLocationOrigin()}/cm/get_buddies/?venue=${this.state.selected_one.venue}`;
    const options = {...defaultOptions};

    return fetch(url, options)
    .then(checkStatus)
    .then(parseJSON)
    .then(data => {
        console.log('result',data)
        this.setState({buddies:data.buddies});
    }).catch(error => error);
    }

  postCreateGame(data, buddies, props) {
    const url = `${getLocationOrigin()}/eagleeye/host_a_game/`;
    const options = {...defaultOptions};
    var venue = data.venue
    var game_type = data.game_type
    var game_level_id = data.game_level_id
    var bud_ids = []
    for( var i in buddies)
    {
      bud_ids.push(buddies[i].id)
    }
    if(!data.venue){venue=this.state.venues[0].id}
    if(!data.game_type){game_type=this.state.game_types[0].pk}
    options['method'] = 'post';
    options['headers'] = {'content-type': 'application/json'}
    options['body'] = JSON.stringify({
                        'venue_id': venue,
                        'game_type_id': game_type,
                        'game_level_id': game_level_id,
                        'start_time': data.start_time,
                        'end_time': data.end_time,
                        'price': data.price,
                        'date': data.date,
                        'batch_size': data.batch_size,
                        'buddies': bud_ids
                      });
    console.log('Going to fetch');
    return fetch(url, options)
      .then(checkStatus)
      .then(parseJSON)
      .then(function(response){                      // first then()
          alert(response.message);
          window.location.reload()
        })
      .catch(error => {
        console.log(error);
        alert(error.message);
      });
  }


  setData(data) {
    var new_selected_one =  Object.assign({}, this.state.selected_one);
    if(!this.state.selected_one.venue){
      new_selected_one['venue'] = data.venues[0].id
      new_selected_one['game_type'] = data.venues[0].game_types[0].pk
      new_selected_one['age_group_id'] = data.age_groups[0].id
      let game_types =  data.venues[0].game_types
      let courts_arr = data.venues[0].game_types[0].courts
      let game_levels = data.venues[0].game_levels
      this.setState({selected_one: new_selected_one,game_types:game_types,courts_arr:courts_arr,game_levels:game_levels});
    }
    else{
      let venue = data.venues.find(each=> each.id == this.state.selected_one.venue)
      console.log('venue',venue)
      new_selected_one['game_type'] = venue.game_types[0].pk
      new_selected_one['age_group_id'] = data.age_groups[0].id
      let game_types = venue.game_types
      let courts_arr = venue.game_types[0].courts
      let game_levels = venue.game_levels
      this.setState({selected_one: new_selected_one,game_types:game_types,courts_arr:courts_arr,game_levels:game_levels});
    }  
  }

  handleVenueChange(event){
    const name = event.target.name
    const value = event.target.value
    const data = this.state.venues.find(each=> each.id == value)
    var new_value =  Object.assign({}, this.state.selected_one);
    new_value[name] = value
    new_value['game_type'] = data.game_types[0].pk
    new_value['game_level_id'] = data.game_levels[0].pk
    this.setState({game_types:data.game_types, selected_one:new_value,courts_arr:data.game_types[0].courts,game_levels:data.game_levels})
  }

  handleDate(date){
    var new_selected_one =  Object.assign({}, this.state.selected_one);
    new_selected_one['date'] = date
    this.setState({selected_one: new_selected_one});
  }

  handleChange(event) {
    const name = event.target.name;
    var new_selected_one =  Object.assign({}, this.state.selected_one);
    new_selected_one[name] = event.target.value
    this.setState({selected_one: new_selected_one});
  }

  onStartTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.selected_one);
    new_value['start_time'] = options
    this.setState({selected_one: new_value});
  }

  onEndTimeChange(options) {
    console.log('options',options)
    var new_value =  Object.assign({}, this.state.selected_one);
    new_value['end_time'] = options
    this.setState({selected_one: new_value});
  }

  handleSubmit(event) {
    event.preventDefault();
    this.postCreateGame(this.state.selected_one, this.state.selected_buddies, this.props);
    console.log('post');
    console.log(this.state);
  }

  onSelect(optionsList, selectedItem) {
    this.state.temp_buddies.push(optionsList)
    this.setState({ selected_buddies: this.state.temp_buddies});
  }

  onChange(dataItem,event){
    this.setState({selected_buddies:dataItem.map(x =>x)});
  }

  render() {
    console.log(this.state.selected_one);
    console.log('sucess');
    console.log(this.state);
    return(
      <div style={styles.container}>
        <div className="row col-md-8 table-bordered" style={styles.table}>
          <div style={styles.main_header} className="col-md-12 label_blue_1">
            Host a Game
          </div>
          <form  className="validated-form form-horizontal" onSubmit={this.handleSubmit}>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Date
              </div>
              <DatePicker selected={this.state.selected_one.date} onChange={this.handleDate}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Venue
              </div>
              <select name="venue" className="col-md-6" style={styles.item_body} value={this.props.venue ? this.props.venue:this.state.value}
                onChange={this.handleVenueChange} disabled={this.props.venue ? 'disabled' : ''}>
                {
                  this.state.venues.map((x, index) => (
                  <option key={x.id} value={x.id}>{x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game type
              </div>
              <select name="game_type" style={styles.item_body} className="col-md-6" value={this.state.value} onChange={this.handleChange}>
                {
                  this.state.game_types.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game + ' ' + x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Game Levels
              </div>
              <select name="game_level_id" style={styles.item_body} className="col-md-6" onChange={this.handleChange}>
                {
                  this.state.game_levels.map((x, index) => (
                  <option key={x.pk} value={x.pk}>{x.game.name + ' ' + x.name}</option>
                  ))
                }
              </select>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={{width:'50%'}} className="col-md-6">
                <div style={styles.item_header} className="col-md-6">
                    <span  style={{display:'contents',marginBottom:'1%',marginBottom:10}}>Start Time </span>
                </div>
                <div className='col-md-6' >
                        <TimePicker style={{width:'100%'}} theme="classic" time={this.state.selected_one.start_time} name='start_time' onTimeChange={this.onStartTimeChange} />
                </div>
              </div>
              <div style={{width:'50%'}} className="col-md-6">
                <div style={styles.item_header} className="col-md-6">
                    <span  style={{display:'contents',marginBottom:'1%',marginBottom:10}}>End Time </span>
                </div>
                <div className='col-md-6' >
                        <TimePicker  style={{width:'100%'}} theme="classic" time={this.state.selected_one.end_time} name='end_time' onTimeChange={this.onEndTimeChange} />
                 </div>
              </div>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Batch Size
              </div>
              <input type="number" style={styles.input} name="batch_size" className="required"
                value={this.state.selected_one.batch_size} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Per Session Price
              </div>
              <input type="number" style={styles.input} name="price" className="required"
                value={this.state.selected_one.price} onChange={this.handleChange}/>
            </div>

            <div style={styles.items} className="col-md-12">
              <div style={styles.item_header} className="col-md-6">
                Buddies
              </div>
              <div className="col-md-6">
                <Multiselect
                  id="1"  
                  placeholder="Buddies"
                  data={this.state.buddies}
                  value = {this.state.selected_buddies}
                  textField='buddy'
                  onSelect={this.onSelect} 
                  onChange={this.onChange}
                  filter='contains' 
                 />
              </div>
            </div>

            <div style={styles.button_submit} className="col-md-12">
              <input className="button1" type="submit" value="Submit"/>
            </div>
            <div className="col-md-12">
              {this.state.data_uploaded?<div className="text-success" style={styles.success}>* Fixture created successfully.</div>:''}
              {this.state.data_error?<div className="text-danger" style={styles.success}>* Error, creation failed.</div>:''}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

export default HostGame;



// WEBPACK FOOTER //
// ./src/app/views/partner/crud/hostGame/index.js